import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './HomePage.css';
import { clearTokens, getCurrentUserAccount } from '../services/authService';

function HomePage() {
  const navigate = useNavigate();
  const [userAccount, setUserAccount] = useState(null);

  useEffect(() => {
    const account = getCurrentUserAccount();
    setUserAccount(account);
  }, []);

  const handleLoginClick = () => {
    navigate('/login');
  };

  const handleLogoutClick = () => {
    clearTokens();
    setUserAccount(null);
    window.location.reload(); // 简单刷新以确状态清除
  };

  const menuItems = [
    {
      id: 'avatar',
      title: '头像生成',
      icon: '🎨',
      desc: '创建个性化的 SVG 风格头像',
      path: '/avatar-generator'
    },
    {
      id: 'avatar-gallery',
      title: '头像画廊',
      icon: '🎨✨',
      desc: '浏览20个随机生成的头像',
      path: '/avatar-gallery'
    }
    // 将来可以在这里添加更多菜单项
  ];

  return (
    <div className="home-container">
      <header className="home-header">
        <div className="logo">WebSocket Portal</div>
        {userAccount ? (
          <div className="header-user-actions">
             <span className="header-greeting">Hi, <strong>{userAccount}</strong></span>
             
             <button 
               className="btn-console"
               onClick={() => navigate('/create-user')}
             >
               进入控制台 ➡️
             </button>

             <button className="btn-login-nav logout" onClick={handleLogoutClick}>
               退出登录
             </button>
          </div>
        ) : (
          <button className="btn-login-nav" onClick={handleLoginClick}>
            登录
          </button>
        )}
      </header>

      <main className="home-content">
        <div className="menu-grid">
           {menuItems.map(item => (
             <div 
                key={item.id} 
                className="menu-card"
                onClick={() => navigate(item.path)}
             >
                <div className="menu-icon">{item.icon}</div>
                <div className="menu-title">{item.title}</div>
                <div className="menu-desc">{item.desc}</div>
             </div>
           ))}
        </div>
      </main>
    </div>
  );
}

export default HomePage;
